<template>
  <div class="setting">
    <!-- <el-popover placement="bottom-end" width="324" trigger="click">
      <div class="item">
        <span>匿名熱線搶接通知</span>
        <el-switch v-model="hasNotify" @change="setNotify"> </el-switch>
      </div>
      <div class="item">
        <span>匿名熱線來電鈴聲</span>
        <el-switch v-model="hasSound" @change="setSound"> </el-switch>
      </div>
      <img
        class="icon-setting"
        src="./images/icon-setting.png"
        slot="reference"
      />
    </el-popover> -->
  </div>
</template>
<script>
export default {
  name: 'Setting',
  props: {},
  data() {
    return {
      hasNotify: false,
      hasSound: false,
      visible: true
    };
  },
  watch: {},
  computed: {},
  methods: {
    setNotify() {},
    setSound() {}
  }
};
</script>
<style lang="scss" scoped>
.setting {
  /deep/ .el-popover__reference-wrapper {
    display: flex;
    align-items: center;
  }
}
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  > span {
    display: inline-block;
    margin-right: 95px;
    color: #111111;
    font-size: 17px;
  }
}
.icon-setting {
  width: 17px;
  cursor: pointer;
}
</style>
